import { ArtifactFileKind } from 'framework/ViewTypes/embeddable';
import { applicationStatuses } from './shared/constants';
import type { ApplicationDetails } from './shared/types';

const davinciPool = { id: 'davinci-project', name: 'Davinci project pool', order: 1 };
const dotnetPool = { id: 'dotnet-engineers', name: '.NET engineers pool', order: 2 };
const businessAnalystsPool = { id: 'business-analysts', name: 'Business analysts pool', order: 3 };
const b2bPool = { id: 'b2b-contractors', name: 'B2B contractors pool', order: 4 };
const legacyPool = { id: 'legacy-hires', name: 'Legacy hires pool' };

const minutesAgo = (minutes: number) => new Date(Date.now() - minutes * 60 * 1000).toISOString();

export const applications: ApplicationDetails[] = [
  {
    id: 1,
    candidateName: 'E.Bubko',
    specialization: 'Software Engineer',
    technology: '.NET',
    level: 'L3',
    stage: 'Evaluating',
    stageStatus: 'General Interview completed',
    stateOwner: 'Elena Markova',
    jobsStates: [
      'ScreeningChecklistPassed',
      'ScreeningInterviewPassed',
      'RoleRelatedInterviewPassed',
      'GeneralInterviewPassed',
    ],
    candidateQualification: 'notStarted',
    createdAt: '2026-09-03T00:00:00',
    pool: davinciPool,
    status: applicationStatuses.ACTIVE,
    jobPostingName: 'L3 .NET Software Engineer',
    tags: ['Student', 'Referral'],
    country: 'Poland',
    language: 'Polish',
    languageLevel: 'B2',
    phone: '+48 501 234 567',
    email: 'elena.bubko@mail.com',
    linkedinUrl: 'https://linkedin.com/in/ebubko',
    telegramUrl: 'https://t.me/ebubko',
    scheduledInterview: {
      type: 'General interview',
      method: 'Online',
      interviewer: 'DaVinci Leonardo',
      scheduledAt: '2026-09-09T11:00:00',
    },
    artifacts: [
      {
        id: '1',
        name: 'E_Bubko_CV.pdf',
        kind: ArtifactFileKind.PDF,
        owner: 'DaVinci Leonardo',
        uploadedAt: '2026-09-03T00:00:00',
      },
    ],
    timeline: [
      {
        id: '1-applied',
        title: 'E.Bubko has applied for L3 .NET Software Engineer',
        occurredAt: '2026-09-03T00:00:00',
        actor: 'DaVinci Leonardo',
      },
    ],
  },
  {
    id: 2,
    candidateName: 'G.Rozhdestvenskiy',
    specialization: 'Software Engineer',
    technology: 'Java',
    level: 'L2',
    stage: 'Evaluating',
    stageStatus: 'Screening Checklist sent',
    stateOwner: 'Elena Markova',
    jobsStates: ['ScreeningChecklistSent'],
    candidateQualification: 'notStarted',
    createdAt: '2026-09-03T00:00:00',
    pool: davinciPool,
    status: applicationStatuses.ACTIVE,
    jobPostingName: 'L2 Java Software Engineer',
    tags: ['Referral'],
    country: 'Belarus',
    language: 'English',
    languageLevel: 'B1',
    phone: '+375 29 111 22 33',
    email: 'g.rozhdestvenskiy@mail.com',
    linkedinUrl: 'https://linkedin.com/in/grozh',
    telegramUrl: '',
    scheduledInterview: null,
    artifacts: [
      {
        id: '1',
        name: 'G_Rozhdestvenskiy_CV.pdf',
        kind: ArtifactFileKind.PDF,
        owner: 'DaVinci Leonardo',
        uploadedAt: '2026-09-03T00:00:00',
      },
    ],
    timeline: [
      {
        id: '2-applied',
        title: 'G.Rozhdestvenskiy has applied for L2 Java Software Engineer',
        occurredAt: '2026-09-03T00:00:00',
        actor: 'DaVinci Leonardo',
      },
    ],
  },
  {
    id: 3,
    candidateName: 'A.Smith',
    specialization: 'Software Engineer',
    technology: 'Java',
    level: 'L2',
    stage: 'Evaluating',
    stageStatus: 'Screening Interview Scheduled',
    stateOwner: 'Elena Markova',
    jobsStates: ['ScreeningChecklistPassed', 'ScreeningInterviewScheduled'],
    candidateQualification: 'notStarted',
    createdAt: '2026-09-02T00:00:00',
    pool: davinciPool,
    status: applicationStatuses.ACTIVE,
    jobPostingName: 'L2 Java Software Engineer',
    tags: [],
    country: 'Poland',
    language: 'English',
    languageLevel: 'C1',
    phone: '+48 502 345 678',
    email: 'a.smith@mail.com',
    linkedinUrl: '',
    telegramUrl: 'https://t.me/asmith',
    scheduledInterview: {
      type: 'Screening interview',
      method: 'Online',
      interviewer: 'DaVinci Leonardo',
      scheduledAt: '2026-09-08T10:00:00',
    },
    artifacts: [
      {
        id: '1',
        name: 'A_Smith_CV.pdf',
        kind: ArtifactFileKind.PDF,
        owner: 'DaVinci Leonardo',
        uploadedAt: '2026-09-02T00:00:00',
      },
    ],
    timeline: [
      {
        id: '3-applied',
        title: 'A.Smith has applied for L2 Java Software Engineer',
        occurredAt: '2026-09-02T00:00:00',
        actor: 'DaVinci Leonardo',
      },
    ],
  },
  {
    id: 4,
    candidateName: 'P.Ivanov',
    specialization: 'Business analyst',
    technology: '-',
    level: 'L4',
    stage: 'Applied',
    stageStatus: 'Waiting for review',
    stateOwner: 'Viktor Sokolov',
    jobsStates: [],
    candidateQualification: 'notStarted',
    createdAt: '2026-09-02T00:00:00',
    pool: davinciPool,
    status: applicationStatuses.ACTIVE,
    jobPostingName: 'L4 Business analyst',
    tags: ['Student'],
    country: 'Belarus',
    language: 'English',
    languageLevel: 'B2',
    phone: '+375 29 222 33 44',
    email: 'p.ivanov@mail.com',
    linkedinUrl: '',
    telegramUrl: '',
    scheduledInterview: null,
    artifacts: [
      {
        id: '1',
        name: 'P_Ivanov_CV.pdf',
        kind: ArtifactFileKind.PDF,
        owner: 'DaVinci Leonardo',
        uploadedAt: '2026-09-02T00:00:00',
      },
    ],
    timeline: [
      {
        id: '4-applied',
        title: 'P.Ivanov has applied for L4 Business analyst',
        occurredAt: '2026-09-02T00:00:00',
        actor: 'DaVinci Leonardo',
      },
    ],
  },
  {
    id: 6,
    candidateName: 'G.Rozhdestvenskiy',
    specialization: 'Software Engineer',
    technology: '.NET',
    level: 'L3',
    stage: 'Evaluating',
    stageStatus: 'Screening Interview Scheduled',
    stateOwner: 'Elena Markova',
    jobsStates: ['ScreeningChecklistPassed', 'ScreeningInterviewScheduled'],
    candidateQualification: 'notStarted',
    createdAt: '2026-09-01T00:00:00',
    pool: dotnetPool,
    status: applicationStatuses.ACTIVE,
    jobPostingName: 'L3 .NET Software Engineer',
    tags: [],
    country: 'Belarus',
    language: 'English',
    languageLevel: 'B2',
    phone: '+375 29 333 44 55',
    email: 'g.rozhdestvenskiy2@mail.com',
    linkedinUrl: '',
    telegramUrl: 'https://t.me/grozh2',
    scheduledInterview: {
      type: 'Screening interview',
      method: 'Online',
      interviewer: 'DaVinci Leonardo',
      scheduledAt: '2026-09-07T12:00:00',
    },
    artifacts: [
      {
        id: '1',
        name: 'G_Rozhdestvenskiy_CV.pdf',
        kind: ArtifactFileKind.PDF,
        owner: 'DaVinci Leonardo',
        uploadedAt: '2026-09-01T00:00:00',
      },
    ],
    timeline: [
      {
        id: '6-applied',
        title: 'G.Rozhdestvenskiy has applied for L3 .NET Software Engineer',
        occurredAt: '2026-09-01T00:00:00',
        actor: 'DaVinci Leonardo',
      },
    ],
  },
  {
    id: 7,
    candidateName: 'L.Caroll',
    specialization: 'Software Engineer',
    technology: '.NET',
    level: 'L2',
    stage: 'Applied',
    stageStatus: 'Waiting for review',
    stateOwner: 'Inga Petrova',
    jobsStates: [],
    candidateQualification: 'notStarted',
    createdAt: '2026-09-01T00:00:00',
    pool: dotnetPool,
    status: applicationStatuses.ACTIVE,
    jobPostingName: 'L2 .NET Software Engineer',
    tags: ['Student'],
    country: 'Poland',
    language: 'English',
    languageLevel: 'B1',
    phone: '+48 504 567 890',
    email: 'l.caroll@mail.com',
    linkedinUrl: 'https://linkedin.com/in/lcaroll',
    telegramUrl: '',
    scheduledInterview: null,
    artifacts: [
      {
        id: '1',
        name: 'L_Caroll_CV.pdf',
        kind: ArtifactFileKind.PDF,
        owner: 'DaVinci Leonardo',
        uploadedAt: '2026-09-01T00:00:00',
      },
    ],
    timeline: [
      {
        id: '7-applied',
        title: 'L.Caroll has applied for L2 .NET Software Engineer',
        occurredAt: '2026-09-01T00:00:00',
        actor: 'DaVinci Leonardo',
      },
    ],
  },
  {
    id: 8,
    candidateName: 'D.Malysheva',
    specialization: 'Software Engineer',
    technology: '.NET',
    level: 'L2',
    stage: 'Applied',
    stageStatus: 'Waiting for review',
    stateOwner: 'Elena Markova',
    jobsStates: [],
    candidateQualification: 'notStarted',
    createdAt: '2026-09-01T00:00:00',
    pool: dotnetPool,
    status: applicationStatuses.ACTIVE,
    jobPostingName: 'L2 .NET Software Engineer',
    tags: [],
    country: 'Belarus',
    language: 'Polish',
    languageLevel: 'A2',
    phone: '+375 29 444 55 66',
    email: 'd.malysheva@mail.com',
    linkedinUrl: '',
    telegramUrl: '',
    scheduledInterview: null,
    artifacts: [
      {
        id: '1',
        name: 'D_Malysheva_CV.pdf',
        kind: ArtifactFileKind.PDF,
        owner: 'DaVinci Leonardo',
        uploadedAt: '2026-09-01T00:00:00',
      },
    ],
    timeline: [
      {
        id: '8-applied',
        title: 'D.Malysheva has applied for L2 .NET Software Engineer',
        occurredAt: '2026-09-01T00:00:00',
        actor: 'DaVinci Leonardo',
      },
    ],
  },
  {
    id: 9,
    candidateName: 'S.Kovalenko',
    specialization: 'Business analyst',
    technology: '-',
    level: 'L3',
    stage: 'Evaluating',
    stageStatus: '',
    stateOwner: 'Elena Markova',
    jobsStates: [],
    candidateQualification: 'notStarted',
    createdAt: '2026-09-01T00:00:00',
    pool: businessAnalystsPool,
    status: applicationStatuses.ACTIVE,
    jobPostingName: 'L3 Business analyst',
    tags: ['Referral'],
    country: 'Belarus',
    language: 'English',
    languageLevel: 'B2',
    phone: '+375 29 555 66 77',
    email: 's.kovalenko@mail.com',
    linkedinUrl: 'https://linkedin.com/in/skovalenko',
    telegramUrl: 'https://t.me/skovalenko',
    scheduledInterview: null,
    artifacts: [
      {
        id: '1',
        name: 'S_Kovalenko_CV.pdf',
        kind: ArtifactFileKind.PDF,
        owner: 'DaVinci Leonardo',
        uploadedAt: '2026-09-01T00:00:00',
      },
    ],
    timeline: [
      {
        id: '9-applied',
        title: 'S.Kovalenko has applied for L3 Business analyst',
        occurredAt: '2026-09-01T00:00:00',
        actor: 'DaVinci Leonardo',
      },
    ],
  },
  {
    id: 11,
    candidateName: 'T.Nowak',
    specialization: 'Software Engineer',
    technology: 'React',
    level: 'L3',
    stage: 'Applied',
    stageStatus: 'Waiting for review',
    stateOwner: 'Elena Markova',
    jobsStates: [],
    candidateQualification: 'notStarted',
    createdAt: '2026-09-04T00:00:00',
    pool: b2bPool,
    status: applicationStatuses.ACTIVE,
    jobPostingName: 'L3 React Software Engineer',
    tags: ['Student', 'Referral'],
    country: 'Poland',
    language: 'Polish',
    languageLevel: 'C1',
    phone: '+48 505 678 901',
    email: 't.nowak@mail.com',
    linkedinUrl: '',
    telegramUrl: 'https://t.me/tnowak',
    scheduledInterview: null,
    artifacts: [
      {
        id: '1',
        name: 'T_Nowak_CV.pdf',
        kind: ArtifactFileKind.PDF,
        owner: 'DaVinci Leonardo',
        uploadedAt: '2026-09-04T00:00:00',
      },
    ],
    timeline: [
      {
        id: '11-applied',
        title: 'T.Nowak has applied for L3 React Software Engineer',
        occurredAt: '2026-09-04T00:00:00',
        actor: 'DaVinci Leonardo',
      },
    ],
  },
  {
    id: 12,
    candidateName: 'R.Kaminski',
    specialization: 'QA Engineer',
    technology: 'Manual',
    level: 'L1',
    stage: 'Evaluating',
    stageStatus: 'General Interview completed',
    stateOwner: 'Viktor Sokolov',
    jobsStates: [
      'ScreeningChecklistPassed',
      'ScreeningInterviewPassed',
      'RoleRelatedInterviewPassed',
      'GeneralInterviewPassed',
    ],
    candidateQualification: 'notStarted',
    createdAt: '2026-09-04T00:00:00',
    pool: b2bPool,
    status: applicationStatuses.ACTIVE,
    jobPostingName: 'L1 Manual QA Engineer',
    tags: [],
    country: 'Poland',
    language: 'Polish',
    languageLevel: 'B2',
    phone: '+48 506 789 012',
    email: 'r.kaminski@mail.com',
    linkedinUrl: 'https://linkedin.com/in/rkaminski',
    telegramUrl: 'https://t.me/rkaminski',
    scheduledInterview: {
      type: 'General interview',
      method: 'Online',
      interviewer: 'DaVinci Leonardo',
      scheduledAt: '2026-09-10T13:00:00',
    },
    artifacts: [
      {
        id: '1',
        name: 'R_Kaminski_CV.pdf',
        kind: ArtifactFileKind.PDF,
        owner: 'DaVinci Leonardo',
        uploadedAt: '2026-09-04T00:00:00',
      },
    ],
    timeline: [
      {
        id: '12-applied',
        title: 'R.Kaminski has applied for L1 Manual QA Engineer',
        occurredAt: '2026-09-04T00:00:00',
        actor: 'DaVinci Leonardo',
      },
    ],
  },
  {
    id: 13,
    candidateName: 'V.Orlov',
    specialization: 'Business analyst',
    technology: '-',
    level: 'L1',
    stage: 'Applied',
    stageStatus: 'Waiting for review',
    stateOwner: 'Elena Markova',
    jobsStates: [],
    candidateQualification: 'notStarted',
    createdAt: '',
    pool: {},
    status: applicationStatuses.ACTIVE,
    jobPostingName: 'L1 Business analyst',
    tags: [],
    country: 'Poland',
    language: 'Polish',
    languageLevel: 'B1',
    phone: '',
    email: 'v.orlov@mail.com',
    linkedinUrl: '',
    telegramUrl: '',
    scheduledInterview: null,
    artifacts: [
      {
        id: '1',
        name: 'V_Orlov_CV.pdf',
        kind: ArtifactFileKind.PDF,
        owner: 'DaVinci Leonardo',
        uploadedAt: '2026-09-05T00:00:00',
      },
    ],
    timeline: [
      {
        id: '13-applied',
        title: 'V.Orlov has applied for L1 Business analyst',
        occurredAt: '2026-09-05T00:00:00',
        actor: 'DaVinci Leonardo',
      },
    ],
  },
  {
    id: 14,
    candidateName: 'N.Petrenko',
    specialization: 'Software Engineer',
    technology: 'Java',
    level: 'L2',
    stage: 'Applied',
    stageStatus: 'Waiting for review',
    stateOwner: 'Inga Petrova',
    jobsStates: [],
    candidateQualification: 'notStarted',
    createdAt: minutesAgo(3 * 24 * 60),
    pool: legacyPool,
    status: applicationStatuses.ACTIVE,
    jobPostingName: 'L2 Java Software Engineer',
    tags: [],
    country: 'Poland',
    language: 'Polish',
    languageLevel: 'B2',
    phone: '',
    email: 'n.petrenko@mail.com',
    linkedinUrl: '',
    telegramUrl: '',
    scheduledInterview: null,
    artifacts: [
      {
        id: '1',
        name: 'N_Petrenko_CV.pdf',
        kind: ArtifactFileKind.PDF,
        owner: 'DaVinci Leonardo',
        uploadedAt: '2026-09-05T00:00:00',
      },
    ],
    timeline: [
      {
        id: '14-applied',
        title: 'N.Petrenko has applied for L2 Java Software Engineer',
        occurredAt: '2026-09-05T00:00:00',
        actor: 'DaVinci Leonardo',
      },
    ],
  },
  {
    id: 15,
    candidateName: 'I.Novak',
    specialization: 'QA Engineer',
    technology: 'Manual',
    level: 'L1',
    stage: 'Applied',
    stageStatus: 'Waiting for review',
    stateOwner: 'Elena Markova',
    jobsStates: [],
    candidateQualification: 'notStarted',
    createdAt: minutesAgo(5 * 60),
    pool: b2bPool,
    status: applicationStatuses.ACTIVE,
    jobPostingName: 'L1 Manual QA Engineer',
    tags: [],
    country: 'Poland',
    language: 'Polish',
    languageLevel: 'B1',
    phone: '',
    email: 'i.novak@mail.com',
    linkedinUrl: '',
    telegramUrl: '',
    scheduledInterview: null,
    artifacts: [
      {
        id: '1',
        name: 'I_Novak_CV.pdf',
        kind: ArtifactFileKind.PDF,
        owner: 'DaVinci Leonardo',
        uploadedAt: '2026-09-05T00:00:00',
      },
    ],
    timeline: [
      {
        id: '15-applied',
        title: 'I.Novak has applied for L1 Manual QA Engineer',
        occurredAt: '2026-09-05T00:00:00',
        actor: 'DaVinci Leonardo',
      },
    ],
  },
  {
    id: 16,
    candidateName: 'O.Marchenko',
    specialization: 'Software Engineer',
    technology: 'React',
    level: 'L3',
    stage: 'Applied',
    stageStatus: 'Waiting for review',
    stateOwner: 'Elena Markova',
    jobsStates: [],
    candidateQualification: 'notStarted',
    createdAt: minutesAgo(25),
    pool: davinciPool,
    status: applicationStatuses.ACTIVE,
    jobPostingName: 'L3 React Software Engineer',
    tags: [],
    country: 'Poland',
    language: 'Polish',
    languageLevel: 'C1',
    phone: '',
    email: 'o.marchenko@mail.com',
    linkedinUrl: '',
    telegramUrl: '',
    scheduledInterview: null,
    artifacts: [
      {
        id: '1',
        name: 'O_Marchenko_CV.pdf',
        kind: ArtifactFileKind.PDF,
        owner: 'DaVinci Leonardo',
        uploadedAt: '2026-09-05T00:00:00',
      },
    ],
    timeline: [
      {
        id: '16-applied',
        title: 'O.Marchenko has applied for L3 React Software Engineer',
        occurredAt: '2026-09-05T00:00:00',
        actor: 'DaVinci Leonardo',
      },
    ],
  },
  {
    id: 17,
    candidateName: 'J.Kowalczyk',
    specialization: 'Software Engineer',
    technology: 'Java',
    level: 'L3',
    stage: 'Qualified',
    stageStatus: 'Offer approval',
    stateOwner: 'Elena Markova',
    jobsStates: [
      'ScreeningChecklistPassed',
      'ScreeningInterviewPassed',
      'RoleRelatedInterviewPassed',
      'GeneralInterviewPassed',
    ],
    candidateQualification: 'initiated',
    rejectionReason: 'Salary expectations',
    createdAt: '2026-09-02T00:00:00',
    pool: dotnetPool,
    status: applicationStatuses.ACTIVE,
    jobPostingName: 'L3 Java Software Engineer',
    tags: ['Referral'],
    country: 'Poland',
    language: 'Polish',
    languageLevel: 'C1',
    phone: '+48 505 111 222',
    email: 'j.kowalczyk@mail.com',
    linkedinUrl: 'https://linkedin.com/in/jkowalczyk',
    telegramUrl: '',
    scheduledInterview: {
      type: 'General interview',
      method: 'Online',
      interviewer: 'DaVinci Leonardo',
      scheduledAt: '2026-09-08T12:00:00',
    },
    artifacts: [
      {
        id: '1',
        name: 'J_Kowalczyk_CV.pdf',
        kind: ArtifactFileKind.PDF,
        owner: 'DaVinci Leonardo',
        uploadedAt: '2026-09-02T00:00:00',
      },
    ],
    timeline: [
      {
        id: '17-applied',
        title: 'J.Kowalczyk has applied for L3 Java Software Engineer',
        occurredAt: '2026-09-02T00:00:00',
        actor: 'DaVinci Leonardo',
      },
    ],
  },
  {
    id: 18,
    candidateName: 'A.Wisniewski',
    specialization: 'Software Engineer',
    technology: 'Java',
    level: 'L2',
    stage: 'Rejected',
    rejectionReason: 'Failed screening',
    rejectedFrom: 'Qualified',
    stageStatus: 'Ready to close',
    stateOwner: 'Viktor Sokolov',
    jobsStates: [
      'ScreeningChecklistPassed',
      'ScreeningInterviewPassed',
      'RoleRelatedInterviewPassed',
      'GeneralInterviewPassed',
    ],
    candidateQualification: 'initiated',
    createdAt: '2026-09-01T00:00:00',
    pool: dotnetPool,
    status: applicationStatuses.INACTIVE,
    jobPostingName: 'L2 Java Software Engineer',
    tags: [],
    country: 'Poland',
    language: 'Polish',
    languageLevel: 'B2',
    phone: '+48 502 777 888',
    email: 'a.wisniewski@mail.com',
    linkedinUrl: '',
    telegramUrl: '',
    scheduledInterview: {
      type: 'General interview',
      method: 'Online',
      interviewer: 'DaVinci Leonardo',
      scheduledAt: '2026-09-06T10:00:00',
    },
    artifacts: [
      {
        id: '1',
        name: 'A_Wisniewski_CV.pdf',
        kind: ArtifactFileKind.PDF,
        owner: 'DaVinci Leonardo',
        uploadedAt: '2026-09-01T00:00:00',
      },
    ],
    timeline: [
      {
        id: '18-applied',
        title: 'A.Wisniewski has applied for L2 Java Software Engineer',
        occurredAt: '2026-09-01T00:00:00',
        actor: 'DaVinci Leonardo',
      },
    ],
  },
  {
    id: 19,
    candidateName: 'M.Nowak',
    specialization: 'Software Engineer',
    technology: '.NET',
    level: 'L3',
    stage: 'Qualified',
    stageStatus: 'Offer approval',
    stateOwner: 'Elena Markova',
    jobsStates: [
      'ScreeningChecklistPassed',
      'ScreeningInterviewPassed',
      'RoleRelatedInterviewPassed',
      'GeneralInterviewPassed',
    ],
    candidateQualification: 'initiated',
    createdAt: '2026-09-01T00:00:00',
    pool: dotnetPool,
    status: applicationStatuses.ACTIVE,
    jobPostingName: 'L3 .NET Software Engineer',
    tags: ['Referral'],
    country: 'Poland',
    language: 'Polish',
    languageLevel: 'C1',
    phone: '+48 505 333 444',
    email: 'm.nowak@mail.com',
    linkedinUrl: 'https://linkedin.com/in/mnowak',
    telegramUrl: '',
    scheduledInterview: {
      type: 'General interview',
      method: 'Online',
      interviewer: 'DaVinci Leonardo',
      scheduledAt: '2026-09-07T12:00:00',
    },
    artifacts: [
      {
        id: '1',
        name: 'M_Nowak_CV.pdf',
        kind: ArtifactFileKind.PDF,
        owner: 'DaVinci Leonardo',
        uploadedAt: '2026-09-01T00:00:00',
      },
    ],
    timeline: [
      {
        id: '19-applied',
        title: 'M.Nowak has applied for L3 .NET Software Engineer',
        occurredAt: '2026-09-01T00:00:00',
        actor: 'DaVinci Leonardo',
      },
    ],
  },
  {
    id: 20,
    candidateName: 'K.Zielinski',
    specialization: 'Software Engineer',
    technology: '.NET',
    level: 'L3',
    stage: 'Offer',
    stageStatus: 'Offer issued',
    stateOwner: 'Inga Petrova',
    jobsStates: [
      'ScreeningChecklistPassed',
      'ScreeningInterviewPassed',
      'RoleRelatedInterviewPassed',
      'GeneralInterviewPassed',
    ],
    candidateQualification: 'initiated',
    createdAt: '2026-09-01T00:00:00',
    pool: dotnetPool,
    status: applicationStatuses.ACTIVE,
    jobPostingName: 'L3 .NET Software Engineer',
    tags: ['Referral'],
    country: 'Poland',
    language: 'Polish',
    languageLevel: 'C1',
    phone: '+48 505 333 444',
    email: 'k.zielinski@mail.com',
    linkedinUrl: 'https://linkedin.com/in/kzielinski',
    telegramUrl: '',
    scheduledInterview: {
      type: 'General interview',
      method: 'Online',
      interviewer: 'DaVinci Leonardo',
      scheduledAt: '2026-09-07T12:00:00',
    },
    artifacts: [
      {
        id: '1',
        name: 'K_Zielinski_CV.pdf',
        kind: ArtifactFileKind.PDF,
        owner: 'DaVinci Leonardo',
        uploadedAt: '2026-09-01T00:00:00',
      },
    ],
    offers: [
      {
        id: 'O001523',
        author: 'John Smith',
        status: 'Pending',
        lastInteractionAt: '2026-09-02T00:00:00',
      },
    ],
    timeline: [
      {
        id: '20-applied',
        title: 'K.Zielinski has applied for L3 .NET Software Engineer',
        occurredAt: '2026-09-01T00:00:00',
        actor: 'DaVinci Leonardo',
      },
    ],
  },
  {
    id: 21,
    candidateName: 'D.Sokolova',
    specialization: 'Business analyst',
    technology: '-',
    level: 'L3',
    stage: 'Evaluating',
    stageStatus: 'Screening Checklist sent',
    stateOwner: 'Elena Markova',
    jobsStates: ['ScreeningChecklistSent'],
    candidateQualification: 'notStarted',
    createdAt: '2026-09-01T00:00:00',
    pool: businessAnalystsPool,
    status: applicationStatuses.ACTIVE,
    jobPostingName: 'L3 Business analyst',
    tags: ['Referral'],
    country: 'Belarus',
    language: 'English',
    languageLevel: 'B2',
    phone: '+375 29 555 66 77',
    email: 'd.sokolova@mail.com',
    linkedinUrl: 'https://linkedin.com/in/dsokolova',
    telegramUrl: 'https://t.me/skovalenko',
    scheduledInterview: null,
    artifacts: [
      {
        id: '1',
        name: 'D_Sokolova_CV.pdf',
        kind: ArtifactFileKind.PDF,
        owner: 'DaVinci Leonardo',
        uploadedAt: '2026-09-01T00:00:00',
      },
    ],
    timeline: [
      {
        id: '21-applied',
        title: 'D.Sokolova has applied for L3 Business analyst',
        occurredAt: '2026-09-01T00:00:00',
        actor: 'DaVinci Leonardo',
      },
    ],
  },
  {
    id: 22,
    candidateName: 'I.Melnyk',
    specialization: 'Business analyst',
    technology: '-',
    level: 'L3',
    stage: 'Evaluating',
    stageStatus: 'Screening Checklist received',
    stateOwner: 'Elena Markova',
    jobsStates: ['ScreeningChecklistReceived'],
    candidateQualification: 'notStarted',
    createdAt: '2026-09-01T00:00:00',
    pool: businessAnalystsPool,
    status: applicationStatuses.ACTIVE,
    jobPostingName: 'L3 Business analyst',
    tags: ['Referral'],
    country: 'Belarus',
    language: 'English',
    languageLevel: 'B2',
    phone: '+375 29 555 66 77',
    email: 'i.melnyk@mail.com',
    linkedinUrl: 'https://linkedin.com/in/imelnyk',
    telegramUrl: 'https://t.me/skovalenko',
    scheduledInterview: null,
    artifacts: [
      {
        id: '1',
        name: 'I_Melnyk_CV.pdf',
        kind: ArtifactFileKind.PDF,
        owner: 'DaVinci Leonardo',
        uploadedAt: '2026-09-01T00:00:00',
      },
    ],
    timeline: [
      {
        id: '22-applied',
        title: 'I.Melnyk has applied for L3 Business analyst',
        occurredAt: '2026-09-01T00:00:00',
        actor: 'DaVinci Leonardo',
      },
    ],
  },
  {
    id: 23,
    candidateName: 'T.Novak',
    specialization: 'Business analyst',
    technology: '-',
    level: 'L3',
    stage: 'Evaluating',
    stageStatus: 'Screening Checklist reviewed',
    stateOwner: 'Elena Markova',
    jobsStates: ['ScreeningChecklistPassed'],
    candidateQualification: 'notStarted',
    createdAt: '2026-09-01T00:00:00',
    pool: businessAnalystsPool,
    status: applicationStatuses.ACTIVE,
    jobPostingName: 'L3 Business analyst',
    tags: ['Referral'],
    country: 'Belarus',
    language: 'English',
    languageLevel: 'B2',
    phone: '+375 29 555 66 77',
    email: 't.novak@mail.com',
    linkedinUrl: 'https://linkedin.com/in/tnovak',
    telegramUrl: 'https://t.me/skovalenko',
    scheduledInterview: null,
    artifacts: [
      {
        id: '1',
        name: 'T_Novak_CV.pdf',
        kind: ArtifactFileKind.PDF,
        owner: 'DaVinci Leonardo',
        uploadedAt: '2026-09-01T00:00:00',
      },
    ],
    timeline: [
      {
        id: '23-applied',
        title: 'T.Novak has applied for L3 Business analyst',
        occurredAt: '2026-09-01T00:00:00',
        actor: 'DaVinci Leonardo',
      },
    ],
  },
  {
    id: 24,
    candidateName: 'L.Varga',
    specialization: 'Business analyst',
    technology: '-',
    level: 'L3',
    stage: 'Evaluating',
    stageStatus: 'Screening Checklist failed',
    stateOwner: 'Viktor Sokolov',
    jobsStates: ['ScreeningChecklistFailed'],
    candidateQualification: 'notStarted',
    createdAt: '2026-09-01T00:00:00',
    pool: businessAnalystsPool,
    status: applicationStatuses.ACTIVE,
    jobPostingName: 'L3 Business analyst',
    tags: ['Referral'],
    country: 'Belarus',
    language: 'English',
    languageLevel: 'B2',
    phone: '+375 29 555 66 77',
    email: 'l.varga@mail.com',
    linkedinUrl: 'https://linkedin.com/in/lvarga',
    telegramUrl: 'https://t.me/skovalenko',
    scheduledInterview: null,
    artifacts: [
      {
        id: '1',
        name: 'L_Varga_CV.pdf',
        kind: ArtifactFileKind.PDF,
        owner: 'DaVinci Leonardo',
        uploadedAt: '2026-09-01T00:00:00',
      },
    ],
    timeline: [
      {
        id: '24-applied',
        title: 'L.Varga has applied for L3 Business analyst',
        occurredAt: '2026-09-01T00:00:00',
        actor: 'DaVinci Leonardo',
      },
    ],
  },
  {
    id: 25,
    candidateName: 'A.Kowalski',
    specialization: 'QA Engineer',
    technology: 'Manual',
    level: 'L1',
    stage: 'Evaluating',
    stageStatus: 'General Interview completed',
    stateOwner: 'Elena Markova',
    jobsStates: [
      'ScreeningChecklistPassed',
      'ScreeningInterviewPassed',
      'RoleRelatedInterviewPassed',
      'GeneralInterviewPassed',
    ],
    candidateQualification: 'initiated',
    createdAt: '2026-09-04T00:00:00',
    pool: b2bPool,
    status: applicationStatuses.ACTIVE,
    jobPostingName: 'L1 Manual QA Engineer',
    tags: [],
    country: 'Poland',
    language: 'Polish',
    languageLevel: 'B2',
    phone: '+48 506 789 012',
    email: 'a.kowalski@mail.com',
    linkedinUrl: 'https://linkedin.com/in/akowalski',
    telegramUrl: 'https://t.me/rkaminski',
    scheduledInterview: {
      type: 'General interview',
      method: 'Online',
      interviewer: 'DaVinci Leonardo',
      scheduledAt: '2026-09-10T13:00:00',
    },
    artifacts: [
      {
        id: '1',
        name: 'A_Kowalski_CV.pdf',
        kind: ArtifactFileKind.PDF,
        owner: 'DaVinci Leonardo',
        uploadedAt: '2026-09-04T00:00:00',
      },
    ],
    timeline: [
      {
        id: '25-applied',
        title: 'A.Kowalski has applied for L1 Manual QA Engineer',
        occurredAt: '2026-09-04T00:00:00',
        actor: 'DaVinci Leonardo',
      },
    ],
  },
  {
    id: 26,
    candidateName: 'P.Zawadzki',
    specialization: 'Software Engineer',
    technology: 'Java',
    level: 'L2',
    stage: 'Closed',
    rejectionReason: 'Failed screening',
    rejectedFrom: 'Qualified',
    stageStatus: 'Closed',
    stateOwner: 'Inga Petrova',
    jobsStates: [
      'ScreeningChecklistPassed',
      'ScreeningInterviewPassed',
      'RoleRelatedInterviewPassed',
      'GeneralInterviewPassed',
    ],
    candidateQualification: 'initiated',
    createdAt: '2026-09-01T00:00:00',
    pool: dotnetPool,
    status: applicationStatuses.INACTIVE,
    jobPostingName: 'L2 Java Software Engineer',
    tags: [],
    country: 'Poland',
    language: 'Polish',
    languageLevel: 'B2',
    phone: '+48 502 777 999',
    email: 'p.zawadzki@mail.com',
    linkedinUrl: '',
    telegramUrl: '',
    scheduledInterview: {
      type: 'General interview',
      method: 'Online',
      interviewer: 'DaVinci Leonardo',
      scheduledAt: '2026-09-06T10:00:00',
    },
    artifacts: [
      {
        id: '1',
        name: 'P_Zawadzki_CV.pdf',
        kind: ArtifactFileKind.PDF,
        owner: 'DaVinci Leonardo',
        uploadedAt: '2026-09-01T00:00:00',
      },
    ],
    timeline: [
      {
        id: '26-applied',
        title: 'P.Zawadzki has applied for L2 Java Software Engineer',
        occurredAt: '2026-09-01T00:00:00',
        actor: 'DaVinci Leonardo',
      },
    ],
  },
  {
    id: 25,
    candidateName: 'G.Rozhdestvenskiy',
    specialization: 'Software Engineer',
    technology: '.NET',
    level: 'L3',
    stage: 'Withdrawn',
    withdrawalReason: 'Accepted another offer',
    rejectedFrom: 'Qualified',
    stageStatus: 'Ready to close',
    stateOwner: 'Elena Markova',
    jobsStates: [
      'ScreeningChecklistPassed',
      'ScreeningInterviewPassed',
      'RoleRelatedInterviewPassed',
      'GeneralInterviewPassed',
    ],
    candidateQualification: 'initiated',
    createdAt: '2026-08-30T00:00:00',
    pool: dotnetPool,
    status: applicationStatuses.INACTIVE,
    jobPostingName: 'L3 .NET Software Engineer',
    tags: [],
    country: 'Belarus',
    language: 'English',
    languageLevel: 'B2',
    phone: '+375 29 555 12 34',
    email: 'g.rozhdestvenskiy@mail.com',
    linkedinUrl: '',
    telegramUrl: '',
    scheduledInterview: null,
    artifacts: [],
    timeline: [
      {
        id: '25-withdrawn',
        title: 'G.Rozhdestvenskiy has withdrawn from L3 .NET Software Engineer',
        occurredAt: '2026-09-20T00:00:00',
        actor: 'Elena Markova',
      },
    ],
  },
];
